function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 47.1,
  cy: 95.8,
  r: 11.2
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 109.1,
  cy: 95.8,
  r: 11.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M145.5 0h-2.7l-35.2 60.9H51.4L16.2 0H0l43.3 75h72.4l35.2-61h20V0z"
});

function SvgCarticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171 107"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCarticon;